import * as appTypes from './app.types';

export const setStateAppReducer = (prop, value) => (dispatch) => {
	dispatch({ type: appTypes.SET_STATE_APP, payload: { prop, value } });
};
